import { City } from '../types';

export const popularCities: City[] = [
  {
    name: 'San Francisco',
    state: 'California',
    slug: 'san-francisco',
    latitude: 37.7749,
    longitude: -122.4194,
    description: 'Home to the oldest and largest Chinatown in North America'
  },
  {
    name: 'New York',
    state: 'New York',
    slug: 'new-york',
    latitude: 40.7128,
    longitude: -74.0060,
    description: 'Features multiple Chinatowns across different boroughs'
  },
  {
    name: 'Los Angeles',
    state: 'California',
    slug: 'los-angeles',
    latitude: 34.0522,
    longitude: -118.2437,
    description: 'Known for authentic regional Chinese cuisines in San Gabriel Valley'
  },
  {
    name: 'Chicago',
    state: 'Illinois',
    slug: 'chicago',
    latitude: 41.8781,
    longitude: -87.6298,
    description: 'Historic Chinatown with traditional dim sum restaurants'
  },
  {
    name: 'Houston',
    state: 'Texas',
    slug: 'houston',
    latitude: 29.7604,
    longitude: -95.3698,
    description: 'Diverse Chinese food scene in Asiatown'
  },
  {
    name: 'Seattle',
    state: 'Washington',
    slug: 'seattle',
    latitude: 47.6062,
    longitude: -122.3321,
    description: 'Rich history of Chinese cuisine in the International District'
  },
  {
    name: 'Boston',
    state: 'Massachusetts',
    slug: 'boston',
    latitude: 42.3601,
    longitude: -71.0589,
    description: 'Historic Chinatown known for seafood and dim sum'
  },
  {
    name: 'Philadelphia',
    state: 'Pennsylvania',
    slug: 'philadelphia',
    latitude: 39.9526,
    longitude: -75.1652,
    description: 'Vibrant Chinatown with diverse regional cuisines'
  },
  {
    name: 'Las Vegas',
    state: 'Nevada',
    slug: 'las-vegas',
    latitude: 36.1699,
    longitude: -115.1398,
    description: 'High-end Chinese restaurants and authentic off-strip gems'
  },
  {
    name: 'Washington',
    state: 'DC',
    slug: 'washington',
    latitude: 38.9072,
    longitude: -77.0369,
    description: 'Chinatown and diverse suburban Chinese dining scenes'
  }
];